import { initUI } from "./init-ui";
import { initRemoServices } from "./init-remo-services";
import { initEnv } from "./init-env";

const tasks: Array<() => void | Promise<void>> = [initEnv, initRemoServices, initUI];

export default tasks;
